@for(item of data; track item.title){
<div class="col gap-4">
    <h4 class="strong">{{ item.title }}</h4>
    <div class="tiny">
        {{ item.question }}
    </div>
    <ul class="w100">
        @for(answer of item.answers; track answer;){ @if(state === false){
        <li>{{ answer }}</li>
        }@else{
        <rr-textarea
            [(ngModel)]="$any(answer)"
            [class.edited]="item.dirty"
            [attr.placeholder]="'Edit value'"
            [fitText]="true"
            class="w100"
        />
        } }
    </ul>
</div>
}
